<template>
	<template
			v-for="action_btn in statusActionsRendered"
			:key="action_btn.index"
		>
	<a 
    	:href="action_btn.url" 
    	class="Btn Btn--small"
    	:data-redirect="getRedirectNode(action_btn)"
		:data-iframe-src="action_btn.url"
		@click="buttonAction(action_btn, $event)"
    	>
		<!-- {{ action_btn.result_event ? 'data-redirect="' ~ ( 'close-module' == action_btn.result_event ? 'close-module' : fn('urldecode', action_btn.redirect_uri)) ~ '"' }} -->						        	
    	<template v-if="'text-button' == action_btn.button_type">
    		{{ action_btn.button_text }}
    	</template>
    	<template v-else-if="'icon-button' == action_btn.button_type">
    		<span :class="action_btn.button_icon"></span>
    	</template>
	</a>
	</template>
</template>

<script>
export default {
	name: 'ButtonsComponent',
	props: {
		statusActionsRendered: {
			type: Array,
			default: [],
			required: true
		}
	},
	data() {
		return {

		}
	},
	inject: {
        detailsViewId: {
            from: 'detailsViewId',
            default: false
        },
        dataLinksTarget: {
            type: String,
            default: 'redirect'
        }
    },
	computed: {
		
	},
	methods: {
		getRedirectNode( action_btn ) {
            if ( ! action_btn.result_event ) return null
            if ( 'close-module' == action_btn.result_event ) {
                return 'close-module'
            }
            return decodeURI(action_btn.result_event)
		},

		buttonAction(action_btn, e) {
			if ( this.detailsViewId ) {
                e.preventDefault()
                const a = e.currentTarget
                this.emitter.emit('processMapButtonClick', {
                    'button': a,
                    'linksTarget': this.dataLinksTarget,
                    'href': action_btn.url,
                    'event': e,
                    'redirect': this.getRedirectNode( action_btn )
                })
                return false
            }
		}
	}
}
</script>